module.exports = __webpack_public_path__ + "static/img/14000571.7cf77a93.png";